import { SCHEDULE_CONFIG as C } from './scheduleConfig';

const pad = (n) => String(n).padStart(2, '0');

/** Ключ дня 'YYYY-MM-DD' из Date (локальное время браузера) */
export function dateKey(d) {
    const x = new Date(d);
    return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
}

/** Ключ дня из строки слота "2026-10-05T10:00:00+05:00" — берём дату как её прислал сервер */
export const slotKey = (t) => String(t).slice(0, 10);

/** 'YYYY-MM-DD' -> Date (полдень по локальному времени, чтобы не ловить сдвиги DST/UTC) */
export function parseKey(key) {
    const [y, m, d] = key.split('-').map(Number);
    return new Date(y, m - 1, d, 12, 0, 0);
}

export function addDays(key, n) {
    const [y, m, d] = key.split('-').map(Number);
    const dt = new Date(y, m - 1, d + n, 12);
    const pad = (x) => String(x).padStart(2, '0');
    return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
}

/** Допустимый диапазон навигации: [сегодня - DAYS_BACK ; сегодня + MAX_MONTHS_AHEAD мес.] */
export function getAllowedRange(now = new Date()) {
    const min = new Date(now);
    min.setDate(min.getDate() - C.DAYS_BACK);
    const max = new Date(now);
    max.setMonth(max.getMonth() + C.MAX_MONTHS_AHEAD);
    return { min: dateKey(min), max: dateKey(max) };
}

export function isDatePassed(key) {
    return  key < new Date().toISOString().slice(0, 10);
}

export function clampKey(key) {
    const { min, max } = getAllowedRange();
    return key < min ? min : key > max ? max : key;
}

export const formatDay = (d) =>
    new Date(d).toLocaleDateString(C.LOCALE, { year: 'numeric', month: 'numeric', day: 'numeric' });

export const formatTime = (d) =>
    new Date(d).toLocaleTimeString(C.LOCALE, { hour: '2-digit', minute: '2-digit' });

export const formatLongDay = (d) =>
    new Date(d).toLocaleDateString('ru-RU', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

export function calcAge(birth, now = new Date()) {
    const b = new Date(birth);
    let age = now.getFullYear() - b.getFullYear();
    if (now < new Date(now.getFullYear(), b.getMonth(), b.getDate())) age--;
    return age;
}

export function yearsLabel(age) {
    const n = Number(age);
    const m100 = n % 100;
    const m10 = n % 10;
    if (m100 >= 11 && m100 <= 14) return 'лет';
    if (m10 === 1) return 'год';
    if (m10 >= 2 && m10 <= 4) return 'года';
    return 'лет';
}

export  const isDate = (v) => /^\d{4}-\d{2}-\d{2}$/.test(v || '') && v >= '2000-01-01';

